<template>
  <v-app>
    <div id="home">
      <section id="headerhomeid">
        <HeaderHome />
      </section>

      <v-main>
        <section id="ourservicehomeid">
          <OurServiceHome />
        </section>

        <v-container fluid>
          <div data-aos="fade-up" data-aos-delay="300">
            <h1
              class="primary--text text-center my-10"
              :style="
                this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
              "
            >
              {{ $t("home.promo") }}
            </h1>
          </div>

          <div data-aos="zoom-in-up" data-aos-delay="500" class="d-flex justify-center">
            <iframe
              src="https://player.vimeo.com/video/524662131"
              :width="this.$vuetify.breakpoint.mdAndUp ? '1000' : '500'"
              :height="this.$vuetify.breakpoint.mdAndUp ? '600' : '300'"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>
          </div>
        </v-container>

        <v-container fluid>
          <div data-aos="fade-up" data-aos-delay="300">
            <h1
              class="primary--text text-center my-10"
              :style="
                this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
              "
            >
              {{ $t("home.tech") }}
            </h1>
          </div>
          <v-parallax :src="require('../../public/oVice.png')" height="650">
            <v-row align="end" justify="center">
              <v-col class="text-center" cols="12">
                <h1
                  class="black--text text-center font-weight-bold"
                  :style="
                    this.$vuetify.breakpoint.mdAndUp
                      ? 'font-size: 50px'
                      : 'font-size: 40px'
                  "
                >
                  oVice
                </h1>
                <v-card class="white">
                  <p
                    :class="
                      this.$vuetify.breakpoint.mdAndUp
                        ? 'black--text text-center font-weight-bold ma-16 pa-16'
                        : 'black--text text-center font-weight-bold ma-5 pa-2'
                    "
                    style="font-size: 18px; line-height: 1.5"
                  >
                    {{ $t("home.techdesc") }}
                  </p>
                </v-card>
              </v-col>
            </v-row>
          </v-parallax>
        </v-container>

        <v-container fluid>
          <div class="my-5">
            <div data-aos="fade-up" data-aos-delay="300">
              <h1
                class="primary--text text-center mt-10"
                :style="
                  this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
                "
              >
                {{ $t("aboutus.ourpartners") }}
              </h1>
            </div>
            <v-container fill-height>
              <v-row class="justify-center align-center">
                <v-col
                  cols="6"
                  sm="6"
                  md="3"
                  lg="2"
                  v-for="partner in partners"
                  :key="partner.src"
                >
                  <a :href="partner.router" target="_blank">
                    <v-img
                      :src="require(`@/assets/partner/` + partner.image)"
                      :min-height="partner.height"
                      :max-width="partner.width"
                      style="margin: 0 auto"
                    >
                    </v-img>
                  </a>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-container>

        <v-container fluid>
          <div data-aos="fade-up" data-aos-delay="300">
            <h1
              class="primary--text text-center my-10"
              :style="
                this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
              "
            >
              {{ $t("home.faqs") }}
            </h1>
            <v-row class="d-flex flex-wrap">
              <v-col
                v-for="(faq, index) in faqs"
                :key="index"
                icon
                cols="12"
                sm="12"
                md="12"
                class="d-flex justify-center"
              >
                <div data-aos="flip-up" data-aos-delay="500">
                  <v-card
                    flat
                    :width="$vuetify.breakpoint.mdAndUp ? 1000 : 350"
                    class="mx-auto"
                  >
                    <v-expansion-panels focusable inset>
                      <v-expansion-panel>
                        <v-expansion-panel-header ripple color="white">
                          <v-card-title class="font-weight-black" style="font-size: 20px">
                            <v-icon size="30px" class="mr-3">
                              {{ faq.icons }}
                            </v-icon>
                            {{ $t(faq.title) }}
                          </v-card-title>
                          <template v-slot:actions>
                            <v-icon> $expand </v-icon>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-card-text
                            class="px-5"
                            style="font-size: 17px; line-height: 1.5"
                          >
                            {{ $t(faq.text) }}
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <ScrollUp />

        <Footer />
      </v-main>
    </div>
  </v-app>
</template>

<script>
// import { onMounted, onUnmounted } from "vue";
import HeaderHome from "@/components/HeaderHome";
import OurServiceHome from "@/components/OurServiceHome";
import ScrollUp from "@/components/ScrollUp";
import Footer from "@/components/Footer";

export default {
  name: "Home",
  components: {
    HeaderHome,
    OurServiceHome,
    ScrollUp,
    Footer,
  },

  methods: {
    scroll() {
      const element = document.getElementById("kit");
      element.scrollIntoView({ behavior: "smooth" });
    },
  },

  data() {
    return {
      overlay: false,
      hover: false,
      fab: false,

      faqs: [
        {
          icons: "mdi-safety-goggles",
          title: "home.what",
          text: "home.whattxt",
        },
        {
          icons: "mdi-plus-circle-outline",
          title: "home.benefits",
          text: "home.benefitstxt",
        },
        {
          icons: "mdi-account-question-outline",
          title: "home.why",
          text: "home.whytxt",
        },
        {
          icons: "mdi-head-question-outline",
          title: "home.expect",
          text: "home.expecttxt",
        },
      ],

      partners: [
        {
          image: "Zeal.png",
          width: "150px",
          height: "110px",
        },
        {
          image: "KGF.png",
          width: "170px",
          height: "140px",
        },
        {
          router: "https://vkirirom.com/",
          image: "vKirirom.png",
          width: "130px",
          height: "100px",
        },
        {
          router: "https://kit.edu.kh/",
          image: "KIT.png",
          width: "150px",
          height: "70px",
        },
        {
          router: "https://quadusk.com/",
          image: "QUADUSK.png",
          width: "110px",
          height: "120px",
        },
      ],
    };
  },
};
</script>

<style scoped>
* {
  font-family: "Montserrat", sans-serif;
}
</style>
